package com.ilussobsa.views.dialogs

import com.ilussobsa.*
import com.ilussobsa.Strings
import com.ilussobsa.sdk.currentSession
import com.ilussobsa.sdk.currentUser
import com.ilussobsa.views.EditVehicleScreen
import com.lightningkite.UUID
import com.lightningkite.kiteui.models.rem
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.navigation.dialogPageNavigator
import com.lightningkite.kiteui.navigation.mainScreenNavigator
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*

class ConfirmUpdateListing(val selectedLot: UUID) : Page {
    val relationship = remember {
        currentUser()?.let { c ->
            currentSession().vehicleRelationship[UserVehiclePair(
                c._id,
                selectedLot
            )]()
        }
    }

    override fun ViewWriter.render() = dismissBackground {
        centered - card - sizeConstraints(
            width = 25.rem,
            height = 10.rem
        ) - col {
            centered - h3(Strings.confirmUpdate)

            centered - text(Strings.allProxyBidsOnThisListingWillBe)
            expanding - space()
            row {
                expanding - col {
                    button {
                        centered - text(Strings.cancel)
                        onClick {
                            navigator.dismiss()
                        }
                    }
                }

                expanding - col {
                    important - button {
                        centered - text("OK")
                        onClick {
                            dialogPageNavigator.clear()
                            mainScreenNavigator.navigate(EditVehicleScreen(selectedLot).apply {
                                flowMode.value = false
                            })
                        }
                    }
                }
            }
        }
    }
}